import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";

export const TfAlertControls = ({ alerts, canEdit, onSaved }) => {
  const [enabled, setEnabled] = useState(alerts.enabled);
  const [threshold, setThreshold] = useState(String(alerts.threshold));
  const [busy, setBusy] = useState(false);
  const dirty = enabled !== alerts.enabled || Number(threshold) !== alerts.threshold;

  const save = async () => {
    const n = Number(threshold);
    if (!(n >= 1 && n <= 100)) { toast.error("Pick a percent from 1 to 100"); return; }
    setBusy(true);
    try {
      await api.patch("/trustedform/coverage/alerts", { enabled, threshold: n });
      toast.success(enabled ? `Alerts on below ${n}%` : "Coverage alerts off");
      onSaved();
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not save");
    } finally { setBusy(false); }
  };

  return (
    <div className="mt-3 border-2 border-black bg-zinc-50 p-3 flex items-center gap-3 flex-wrap" data-testid="tf-alert-controls">
      <div className="label-mono">Email admins when a page drops below</div>
      <input type="number" min="1" max="100" value={threshold} disabled={!canEdit} onChange={(e) => setThreshold(e.target.value)}
             className="border-2 border-black px-2 py-1 w-20 text-xs" data-testid="tf-alert-threshold" />
      <span className="text-xs">% (last 24 hours, pages with {alerts.min_leads}+ leads, at most once a day per page)</span>
      <div className="ml-auto flex items-center gap-2">
        <span className="text-[10px] uppercase tracking-widest" data-testid="tf-alert-label">{enabled ? "On" : "Off"}</span>
        <Switch checked={enabled} disabled={!canEdit} onCheckedChange={setEnabled} data-testid="tf-alert-toggle" />
        {canEdit ? (
          <button type="button" onClick={save} disabled={!dirty || busy} data-testid="tf-alert-save"
                  className="border-2 border-black bg-black text-white px-3 py-1 text-[10px] uppercase tracking-widest disabled:opacity-40">
            Save
          </button>
        ) : <span className="text-[10px] text-zinc-500" data-testid="tf-alert-readonly">Admins can change this</span>}
      </div>
    </div>
  );
};
